/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoGallery_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedInteriorsHeader_itemSearch">;
    readonly " $refType": "SbRespInteriorsPhotoGallery_itemSearch";
};
export type SbRespInteriorsPhotoGallery_itemSearch$data = SbRespInteriorsPhotoGallery_itemSearch;
export type SbRespInteriorsPhotoGallery_itemSearch$key = {
    readonly " $data"?: SbRespInteriorsPhotoGallery_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsPhotoGallery_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsPhotoGallery_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedInteriorsHeader_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'f07b5e762572db307667e2a91206e43e';
export default node;
